import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import {
  catchError,
  filter,
  map,
  of,
  retryWhen,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs';

import { retryStrategy } from '@personal-area/global/http/services';

import { DictionaryService } from '../../services/dictionary.service';
import {
  GetAllCountries,
  GetAllCountriesFail,
  GetAllCountriesSuccess,
  SetAllCountriesLoading,
} from '../actions/all-countries';
import {
  areAllCountriesLoaded,
  areAllCountriesLoading,
} from '../selectors/all-countries';

@Injectable()
export class AllCountriesEffects {
  constructor(
    private _store: Store,
    private _actions$: Actions,
    private _dictionaryService: DictionaryService,
  ) {}

  getAllCountries$ = createEffect(() =>
    this._actions$.pipe(
      ofType(GetAllCountries),
      withLatestFrom(
        this._store.select(areAllCountriesLoading),
        this._store.select(areAllCountriesLoaded),
        (action, areCountriesLoading, areCountriesLoaded) =>
          areCountriesLoading === false && areCountriesLoaded === false,
      ),
      filter((flag) => flag),
      tap(() => this._store.dispatch(SetAllCountriesLoading())),
      switchMap(() =>
        this._dictionaryService.fetchCountries(true).pipe(
          retryWhen(retryStrategy()),
          map((countries) => GetAllCountriesSuccess(countries)),
          catchError((error) => of(GetAllCountriesFail(error))),
        ),
      ),
    ),
  );
}
